(function () {
  if (window.QLSHeaderDeliveryCheckerV124Loaded) return;
  window.QLSHeaderDeliveryCheckerV124Loaded = true;

  var ZIP_STORAGE_KEY = 'qls_shipping_estimator_zip';
  var RESULT_STORAGE_KEY = 'qls_header_delivery_result';
  var NOMINATIM_REVERSE_ENDPOINT = 'https://nominatim.openstreetmap.org/reverse';

  var ZIP_STATE_RANGES = [
    [6, 9, 'PR', 'Puerto Rico / U.S. Virgin Islands'],
    [10, 27, 'MA', 'Massachusetts'],
    [28, 29, 'RI', 'Rhode Island'],
    [30, 38, 'NH', 'New Hampshire'],
    [39, 49, 'ME', 'Maine'],
    [50, 59, 'VT', 'Vermont'],
    [60, 69, 'CT', 'Connecticut'],
    [70, 89, 'NJ', 'New Jersey'],
    [90, 98, 'AE', 'Armed Forces Europe'],
    [100, 149, 'NY', 'New York'],
    [150, 196, 'PA', 'Pennsylvania'],
    [197, 199, 'DE', 'Delaware'],
    [200, 200, 'DC', 'District of Columbia'],
    [201, 201, 'VA', 'Virginia'],
    [202, 205, 'DC', 'District of Columbia'],
    [206, 212, 'MD', 'Maryland'],
    [220, 246, 'VA', 'Virginia'],
    [247, 268, 'WV', 'West Virginia'],
    [270, 289, 'NC', 'North Carolina'],
    [290, 299, 'SC', 'South Carolina'],
    [300, 319, 'GA', 'Georgia'],
    [320, 339, 'FL', 'Florida'],
    [341, 349, 'FL', 'Florida'],
    [350, 352, 'AL', 'Alabama'],
    [354, 369, 'AL', 'Alabama'],
    [370, 385, 'TN', 'Tennessee'],
    [386, 397, 'MS', 'Mississippi'],
    [398, 399, 'GA', 'Georgia'],
    [400, 427, 'KY', 'Kentucky'],
    [430, 459, 'OH', 'Ohio'],
    [460, 479, 'IN', 'Indiana'],
    [480, 499, 'MI', 'Michigan'],
    [500, 528, 'IA', 'Iowa'],
    [530, 549, 'WI', 'Wisconsin'],
    [550, 567, 'MN', 'Minnesota'],
    [570, 577, 'SD', 'South Dakota'],
    [580, 588, 'ND', 'North Dakota'],
    [590, 599, 'MT', 'Montana'],
    [600, 629, 'IL', 'Illinois'],
    [630, 658, 'MO', 'Missouri'],
    [660, 679, 'KS', 'Kansas'],
    [680, 693, 'NE', 'Nebraska'],
    [700, 715, 'LA', 'Louisiana'],
    [716, 729, 'AR', 'Arkansas'],
    [730, 749, 'OK', 'Oklahoma'],
    [750, 799, 'TX', 'Texas'],
    [800, 816, 'CO', 'Colorado'],
    [820, 831, 'WY', 'Wyoming'],
    [832, 838, 'ID', 'Idaho'],
    [840, 847, 'UT', 'Utah'],
    [850, 853, 'AZ', 'Arizona'],
    [855, 857, 'AZ', 'Arizona'],
    [859, 860, 'AZ', 'Arizona'],
    [863, 865, 'AZ', 'Arizona'],
    [870, 884, 'NM', 'New Mexico'],
    [889, 898, 'NV', 'Nevada'],
    [900, 961, 'CA', 'California'],
    [967, 968, 'HI', 'Hawaii'],
    [969, 969, 'GU', 'Guam / Northern Mariana Islands'],
    [970, 979, 'OR', 'Oregon'],
    [980, 994, 'WA', 'Washington'],
    [995, 999, 'AK', 'Alaska']
  ];

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function normalizeZip(value) {
    var digits = digitsOnly(value).slice(0, 9);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function isValidZip(value) {
    return /^\d{5}(?:-\d{4})?$/.test(String(value || '').trim());
  }

  function firstFive(value) {
    return digitsOnly(value).slice(0, 5);
  }

  function stateFromZip(value) {
    var zip = firstFive(value);
    var prefix = parseInt(zip.slice(0, 3), 10);

    if (Number.isNaN(prefix)) return null;

    /* A few territory ZIPs share otherwise state-level prefixes. */
    if (zip === '96799') return { code: 'AS', name: 'American Samoa' };
    if (/^9695[0-2]$/.test(zip)) return { code: 'MP', name: 'Northern Mariana Islands' };
    if (/^008/.test(zip)) return { code: 'VI', name: 'U.S. Virgin Islands' };

    for (var i = 0; i < ZIP_STATE_RANGES.length; i += 1) {
      var range = ZIP_STATE_RANGES[i];
      if (prefix >= range[0] && prefix <= range[1]) {
        return { code: range[2], name: range[3] };
      }
    }

    return null;
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* Private browsing can block localStorage. The checker still works. */
    }
  }

  function removeStorage(key) {
    try { window.localStorage.removeItem(key); } catch (error) {}
  }

  function parseBlockedStates(value) {
    return new Set(
      String(value || '')
        .toUpperCase()
        .split(/[\s,;|]+/)
        .map(function (item) { return item.trim(); })
        .filter(Boolean)
    );
  }

  function extractZipFromAddress(address) {
    var postcode = address && address.postcode ? String(address.postcode) : '';
    var match = postcode.match(/\b\d{5}\b/);
    return match ? match[0] : '';
  }

  if (!customElements.get('qls-delivery-checker')) {
    class QLSDeliveryChecker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.instanceId = this.dataset.instanceId || String(Math.random());
        this.defaultLabel = this.dataset.defaultLabel || 'Check delivery';
        this.defaultSupport = this.dataset.defaultSupport || 'Ships to 40+ states';
        this.blockedStates = parseBlockedStates(this.dataset.blockedStates);
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-qls-delivery-input]');
        this.status = this.querySelector('[data-qls-delivery-status]');
        this.locateButton = this.querySelector('[data-qls-delivery-locate]');
        this.clearButton = this.querySelector('[data-qls-delivery-clear]');
        this.drawerDetails = this.closest('[data-qls-mobile-menu-delivery]');
        this.headerDetails = this.closest('[data-qls-delivery-menu]');
        this.drawerSummary = this.drawerDetails ? this.drawerDetails.querySelector(':scope > summary') : null;
        this.headerSummary = this.headerDetails ? this.headerDetails.querySelector(':scope > summary') : null;

        if (!this.form || !this.input || !this.status || !this.locateButton) return;

        this.boundHandleSubmit = this.handleSubmit.bind(this);
        this.boundHandleInput = this.handleInput.bind(this);
        this.boundHandleLocate = this.handleLocate.bind(this);
        this.boundHandleClear = this.handleClear.bind(this);
        this.boundHandleExternalClear = this.handleExternalClear.bind(this);
        this.boundHandleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.boundHandleHeaderToggle = this.handleHeaderToggle.bind(this);
        this.boundPositionHeaderPanel = this.positionHeaderPanel.bind(this);
        this.boundHandleExternalUpdate = this.handleExternalUpdate.bind(this);
        this.boundHandleInputFocus = this.handleInputFocus.bind(this);
        this.boundHandleInputBlur = this.handleInputBlur.bind(this);
        this.boundHandleSummaryClick = this.handleSummaryClick.bind(this);

        this.form.addEventListener('submit', this.boundHandleSubmit);
        this.input.addEventListener('input', this.boundHandleInput);
        this.input.addEventListener('focus', this.boundHandleInputFocus);
        this.input.addEventListener('blur', this.boundHandleInputBlur);
        this.locateButton.addEventListener('click', this.boundHandleLocate);
        if (this.clearButton) this.clearButton.addEventListener('click', this.boundHandleClear);
        if (this.drawerDetails) {
          this.drawerDetails.addEventListener('toggle', this.boundHandleDrawerToggle);
          if (this.drawerSummary) this.drawerSummary.addEventListener('click', this.boundHandleSummaryClick);
        }
        if (this.headerDetails) {
          this.headerDetails.addEventListener('toggle', this.boundHandleHeaderToggle);
          if (this.headerSummary) this.headerSummary.addEventListener('click', this.boundHandleSummaryClick);
          window.addEventListener('resize', this.boundPositionHeaderPanel, { passive: true });
          if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.boundPositionHeaderPanel, { passive: true });
          }
        }
        window.addEventListener('qls:delivery-check-updated', this.boundHandleExternalUpdate);
        window.addEventListener('qls:delivery-check-cleared', this.boundHandleExternalClear);

        var storedZip = normalizeZip(readStorage(ZIP_STORAGE_KEY));
        if (isValidZip(storedZip)) {
          this.input.value = storedZip;
          this.resolveZip(storedZip, { broadcast: false });
        } else {
          this.setState('', this.defaultSupport);
        }
        this.updateClearButton();
      }


      focusInputNow() {
        if (!this.input) return;
        window.QLSMobileInputFocusGuardUntil = Date.now() + 3200;
        try { this.input.focus({ preventScroll: true }); } catch (error) { this.input.focus(); }
        try {
          var end = String(this.input.value || '').length;
          this.input.setSelectionRange(end, end);
        } catch (error) {}
      }

      handleSummaryClick(event) {
        var details = event.currentTarget && event.currentTarget.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;
        if (details.open) return;

        /* Manually open and focus during the actual tap. Delayed focus does not
           summon the iOS keyboard when the page has already been scrolled. */
        event.preventDefault();
        details.open = true;
        if (details === this.headerDetails) {
          this.headerDetails.dataset.qlsOpenedScrollY = String(window.scrollY || window.pageYOffset || 0);
          this.positionHeaderPanel();
        }
        this.focusInputNow();
      }

      handleInputFocus() {
        this.inputFocused = true;
        this.focusScrollY = window.scrollY || window.pageYOffset || 0;
        window.QLSMobileInputFocusGuardUntil = Date.now() + 3200;

        if (this.headerDetails) {
          this.headerDetails.dataset.qlsInputFocused = 'true';
          this.headerDetails.dataset.qlsOpenedScrollY = String(this.focusScrollY);
        }

        document.documentElement.classList.add('qls-mobile-delivery-focus');
      }

      handleInputBlur() {
        var self = this;
        window.setTimeout(function () {
          if (document.activeElement === self.input) return;
          self.inputFocused = false;
          if (self.headerDetails) delete self.headerDetails.dataset.qlsInputFocused;
          document.documentElement.classList.remove('qls-mobile-delivery-focus');
        }, 280);
      }

      stabilizeInputFocus() {
        if (!this.inputFocused || document.activeElement !== this.input) return;
        window.QLSMobileInputFocusGuardUntil = Date.now() + 2200;
      }

      handleSubmit(event) {
        event.preventDefault();
        this.resolveZip(this.input.value, { broadcast: true });
      }

      handleInput() {
        var normalized = normalizeZip(this.input.value);
        if (this.input.value !== normalized) this.input.value = normalized;
        if (!normalized) {
          this.clearDelivery({ broadcast: true, keepFocus: true });
          return;
        }
        this.updateClearButton();
        this.setState('', this.defaultSupport, null);
      }

      updateClearButton() {
        if (this.clearButton) this.clearButton.hidden = !String(this.input && this.input.value || '').trim();
      }

      handleClear() {
        this.clearDelivery({ broadcast: true, keepFocus: true });
      }

      handleExternalClear(event) {
        var detail = event && event.detail || {};
        if (detail.source === this.instanceId) return;
        this.clearDelivery({ broadcast: false, keepFocus: false });
      }

      clearDelivery(options) {
        options = options || {};
        removeStorage(ZIP_STORAGE_KEY);
        removeStorage(RESULT_STORAGE_KEY);
        removeStorage('qls_delivery_postcode');
        removeStorage('qls_delivery_postcode_checked');
        if (this.input) this.input.value = '';
        this.setState('', this.defaultSupport, null);
        this.updateClearButton();
        if (options.broadcast !== false) {
          window.dispatchEvent(new CustomEvent('qls:delivery-check-cleared', {
            detail: { source: this.instanceId }
          }));
        }
        if (options.keepFocus && this.input) this.focusInputNow();
      }

      resolveZip(value, options) {
        options = options || {};
        var zip = normalizeZip(value);

        this.input.value = zip;
        this.updateClearButton();

        if (!isValidZip(zip)) {
          this.setState('error', 'Enter a valid 5-digit ZIP or ZIP+4.');
          return;
        }

        var state = stateFromZip(zip);
        var result;

        if (!state) {
          result = {
            zip: zip,
            state: '',
            stateCode: '',
            availability: 'unknown',
            message: 'Please confirm this ZIP at checkout.'
          };
        } else if (this.blockedStates.has(state.code)) {
          result = {
            zip: zip,
            state: state.name,
            stateCode: state.code,
            availability: 'error',
            message: 'We do not currently ship to ' + state.name + '.'
          };
        } else {
          result = {
            zip: zip,
            state: state.name,
            stateCode: state.code,
            availability: 'success',
            message: 'Delivery available to ' + state.name + '.'
          };
        }

        writeStorage(ZIP_STORAGE_KEY, zip);
        writeStorage(RESULT_STORAGE_KEY, JSON.stringify(result));
        this.applyResult(result);

        if (result.availability === 'success' || result.availability === 'unknown') {
          this.closeDesktopPanelSoon();
          this.closeDrawerPanelSoon();
        }

        if (options.broadcast !== false) {
          window.dispatchEvent(new CustomEvent('qls:delivery-check-updated', {
            detail: { source: this.instanceId, result: result }
          }));
        }
      }

      applyResult(result) {
        if (!result) return;
        if (this.input && result.zip) this.input.value = result.zip;
        this.updateClearButton();
        this.setState(result.availability || 'unknown', result.message || this.defaultSupport, result);
      }

      closeDesktopPanelSoon() {
        var desktop = this.closest('[data-qls-delivery-desktop]');
        if (!desktop || !desktop.hasAttribute('open')) return;

        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(function () {
          desktop.removeAttribute('open');
        }, 900);
      }

      closeDrawerPanelSoon() {
        var drawer = this.drawerDetails || this.closest('[data-qls-mobile-menu-delivery]');
        if (!drawer || !drawer.hasAttribute('open')) return;

        window.clearTimeout(this.drawerCloseTimer);
        this.drawerCloseTimer = window.setTimeout(function () {
          drawer.removeAttribute('open');
        }, 1250);
      }

      handleDrawerToggle() {
        if (!this.drawerDetails || !this.drawerDetails.open) return;
        this.drawerDetails.dataset.qlsOpenedAt = String(Date.now());
        var self = this;
        window.requestAnimationFrame(function () {
          if (document.activeElement !== self.input) self.focusInputNow();
        });
      }

      handleHeaderToggle() {
        if (!this.headerDetails || !this.headerDetails.open) return;
        this.headerDetails.dataset.qlsOpenedScrollY = String(window.scrollY || window.pageYOffset || 0);
        this.positionHeaderPanel();
        var self = this;
        window.requestAnimationFrame(function () {
          if (document.activeElement !== self.input) self.focusInputNow();
        });
      }

      positionHeaderPanel() {
        if (!this.headerDetails || !this.headerDetails.open) return;

        /* iOS changes visualViewport dimensions when the keyboard opens. Keep
           the already-positioned fixed panel stable while its input is active. */
        if (this.inputFocused && this.headerDetails.style.getPropertyValue('--qls-delivery-panel-top')) {
          this.stabilizeInputFocus();
          return;
        }

        var header = this.headerDetails.closest('store-header') || document.querySelector('store-header');
        var viewport = window.visualViewport;
        var viewportTop = viewport ? viewport.offsetTop : 0;
        var viewportHeight = viewport ? viewport.height : window.innerHeight;
        var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        var desiredTop = Math.max(viewportTop + 8, headerBottom + 8);
        var maxTop = Math.max(viewportTop + 8, viewportTop + viewportHeight - 170);
        var top = Math.min(desiredTop, maxTop);

        this.headerDetails.style.setProperty('--qls-delivery-panel-top', Math.round(top) + 'px');
      }

      disconnectedCallback() {
        if (this.form && this.boundHandleSubmit) this.form.removeEventListener('submit', this.boundHandleSubmit);
        if (this.input && this.boundHandleInput) this.input.removeEventListener('input', this.boundHandleInput);
        if (this.input && this.boundHandleInputFocus) this.input.removeEventListener('focus', this.boundHandleInputFocus);
        if (this.input && this.boundHandleInputBlur) this.input.removeEventListener('blur', this.boundHandleInputBlur);
        if (this.locateButton && this.boundHandleLocate) this.locateButton.removeEventListener('click', this.boundHandleLocate);
        if (this.clearButton && this.boundHandleClear) this.clearButton.removeEventListener('click', this.boundHandleClear);
        if (this.drawerDetails && this.boundHandleDrawerToggle) this.drawerDetails.removeEventListener('toggle', this.boundHandleDrawerToggle);
        if (this.drawerSummary && this.boundHandleSummaryClick) this.drawerSummary.removeEventListener('click', this.boundHandleSummaryClick);
        if (this.headerDetails && this.boundHandleHeaderToggle) this.headerDetails.removeEventListener('toggle', this.boundHandleHeaderToggle);
        if (this.headerSummary && this.boundHandleSummaryClick) this.headerSummary.removeEventListener('click', this.boundHandleSummaryClick);
        if (this.boundPositionHeaderPanel) {
          window.removeEventListener('resize', this.boundPositionHeaderPanel);
          if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.boundPositionHeaderPanel);
        }
        if (this.boundHandleExternalUpdate) window.removeEventListener('qls:delivery-check-updated', this.boundHandleExternalUpdate);
        if (this.boundHandleExternalClear) window.removeEventListener('qls:delivery-check-cleared', this.boundHandleExternalClear);
      }

      setState(state, message, result) {
        if (state) {
          this.dataset.state = state;
        } else {
          delete this.dataset.state;
        }

        this.status.textContent = message || this.defaultSupport;

        var hosts = [
          this.closest('[data-qls-delivery-menu]'),
          this.closest('[data-qls-delivery-desktop]')
        ].filter(Boolean);

        hosts.forEach(function (host) {
          var badge = host.querySelector('[data-qls-delivery-badge]');
          if (!badge) return;

          if (state) {
            badge.hidden = false;
            badge.dataset.state = state;
          } else {
            badge.hidden = true;
            delete badge.dataset.state;
          }
        });

        var drawer = this.drawerDetails || this.closest('[data-qls-mobile-menu-delivery]');
        if (drawer) {
          var drawerSummary = drawer.querySelector('[data-qls-mobile-delivery-summary]');
          if (drawerSummary) {
            if (state === 'success' && result && result.state) {
              drawerSummary.textContent = 'Delivery available to ' + result.state + '.';
            } else if (state === 'error' && result && result.state) {
              drawerSummary.textContent = 'Not available to ' + result.state + '.';
            } else if (state === 'unknown') {
              drawerSummary.textContent = 'Confirm this ZIP at checkout.';
            } else {
              drawerSummary.textContent = message || this.defaultSupport;
            }
            drawerSummary.dataset.state = state || '';
          }
        }

        var desktop = this.closest('[data-qls-delivery-desktop]');
        if (desktop) {
          var summaryLabel = desktop.querySelector('[data-qls-delivery-summary-label]');
          var summaryStatus = desktop.querySelector('[data-qls-delivery-summary-status]');
          var resultZip = result && result.zip ? firstFive(result.zip) : '';

          if (summaryLabel) {
            summaryLabel.textContent = resultZip ? 'Deliver to ' + resultZip : this.defaultLabel;
          }
          if (summaryStatus) {
            if (state === 'success' && result && result.state) {
              summaryStatus.textContent = 'Available in ' + result.state;
            } else if (state === 'error' && result && result.state) {
              summaryStatus.textContent = 'Unavailable in ' + result.state;
            } else if (state === 'unknown') {
              summaryStatus.textContent = 'Confirm at checkout';
            } else {
              summaryStatus.textContent = message || this.defaultSupport;
            }
            summaryStatus.dataset.state = state || '';
          }
        }
      }

      handleExternalUpdate(event) {
        var detail = event.detail || {};
        if (detail.source === this.instanceId) return;
        if (detail.result) {
          this.applyResult(detail.result);
          return;
        }
        if (detail.zip && isValidZip(normalizeZip(detail.zip))) {
          this.resolveZip(detail.zip, { broadcast: false });
        }
      }

      setLocateLoading(isLoading) {
        this.locateButton.disabled = !!isLoading;
        this.locateButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }

      handleLocate() {
        var self = this;

        if (!window.isSecureContext || !navigator.geolocation) {
          this.setState('error', 'Enter your ZIP code manually.');
          return;
        }

        this.setLocateLoading(true);
        this.setState('', 'Your browser may ask for permission.');

        navigator.geolocation.getCurrentPosition(function (position) {
          var coords = position && position.coords;
          if (!coords) {
            self.setState('error', 'Enter your ZIP code manually.');
            self.setLocateLoading(false);
            return;
          }

          var params = new URLSearchParams({
            format: 'jsonv2',
            lat: String(coords.latitude),
            lon: String(coords.longitude),
            zoom: '18',
            addressdetails: '1',
            'accept-language': 'en'
          });

          fetch(NOMINATIM_REVERSE_ENDPOINT + '?' + params.toString(), {
            method: 'GET',
            headers: { Accept: 'application/json' },
            referrerPolicy: 'strict-origin-when-cross-origin'
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Location lookup failed');
              return response.json();
            })
            .then(function (data) {
              var address = data && data.address ? data.address : {};
              var countryCode = String(address.country_code || '').toLowerCase();

              if (countryCode && countryCode !== 'us') {
                self.setState('error', 'We only deliver within the United States.');
                return;
              }

              var zip = extractZipFromAddress(address);
              if (!zip) {
                self.setState('error', 'Enter your ZIP code manually.');
                return;
              }

              self.input.value = zip;
              self.resolveZip(zip, { broadcast: true });
            })
            .catch(function () {
              self.setState('error', 'Enter your ZIP code manually.');
            })
            .finally(function () {
              self.setLocateLoading(false);
            });
        }, function () {
          self.setState('error', 'Enter your ZIP code manually.');
          self.setLocateLoading(false);
        }, {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 600000
        });
      }
    }

    customElements.define('qls-delivery-checker', QLSDeliveryChecker);
  }

  window.QLSCloseHeaderDeliveryMenus = function () {
    document.querySelectorAll('[data-qls-delivery-menu][open], [data-qls-delivery-desktop][open]').forEach(function (menu) {
      menu.removeAttribute('open');
    });
  };

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest && event.target.closest('[data-qls-delivery-panel-close]');
    if (closeButton) {
      event.preventDefault();
      var closeHost = closeButton.closest('[data-qls-delivery-menu], [data-qls-delivery-desktop]');
      if (closeHost) {
        closeHost.removeAttribute('open');
        var closeSummary = closeHost.querySelector('summary');
        if (closeSummary) closeSummary.focus({ preventScroll: true });
      }
      return;
    }

    document.querySelectorAll('[data-qls-delivery-menu][open], [data-qls-delivery-desktop][open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  window.addEventListener('scroll', function () {
    var currentScrollY = window.scrollY || window.pageYOffset || 0;
    document.querySelectorAll('[data-qls-delivery-menu][open]').forEach(function (menu) {
      var active = document.activeElement;
      var inputIsActive = !!(active && menu.contains(active) && active.matches('input, textarea, select'));
      var focusGuardActive = Date.now() < Number(window.QLSMobileInputFocusGuardUntil || 0);

      /* Keyboard opening can generate a synthetic scroll/viewport shift on
         iOS. Never treat that as the customer's request to close the panel. */
      if (inputIsActive || menu.dataset.qlsInputFocused === 'true' || focusGuardActive) return;

      var openedAt = Number(menu.dataset.qlsOpenedScrollY || currentScrollY);
      if (Math.abs(currentScrollY - openedAt) > 12) menu.removeAttribute('open');
    });
  }, { passive: true });

  /* The enhanced mobile drawer has its own scroll surface. Close the expanded
     ZIP area when the customer scrolls that surface, rather than making them
     travel back to the chevron. Capture is required because scroll does not
     bubble. */
  document.addEventListener('scroll', function (event) {
    var target = event.target;
    if (!target || target === document || target === window || !target.closest) return;
    var menu = target.closest('main-menu');
    if (!menu) return;

    menu.querySelectorAll('[data-qls-mobile-menu-delivery][open]').forEach(function (details) {
      var openedAt = Number(details.dataset.qlsOpenedAt || 0);
      if (openedAt && Date.now() - openedAt < 280) return;

      var active = document.activeElement;
      if (active && details.contains(active) && active.blur) active.blur();
      details.removeAttribute('open');
    });
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-qls-delivery-menu][open], [data-qls-delivery-desktop][open]').forEach(function (menu) {
      menu.removeAttribute('open');
      var summary = menu.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  /* Keep every QLS/product/cart ZIP entry in sync through the same localStorage
     key. This also covers compatible app fields that use postal-code metadata. */
  (function initDeliveryZipBridge() {
    var selector = [
      '[data-qls-delivery-input]',
      'shipping-calculator .js-zip-input',
      'input[autocomplete="postal-code"]',
      'input[name*="zip" i]',
      'input[id*="zip" i]',
      'input[placeholder*="ZIP" i]'
    ].join(',');
    var syncing = false;

    document.addEventListener('focusin', function (event) {
      var input = event.target && event.target.matches && event.target.matches(selector) ? event.target : null;
      if (input) input.dataset.qlsUserEditing = 'true';
    });
    document.addEventListener('focusout', function (event) {
      var input = event.target && event.target.matches && event.target.matches(selector) ? event.target : null;
      if (!input) return;
      window.setTimeout(function () { delete input.dataset.qlsUserEditing; }, 400);
    });

    function syncInputs(zip, source) {
      zip = normalizeZip(zip);
      if (!isValidZip(zip)) return;
      syncing = true;
      document.querySelectorAll(selector).forEach(function (input) {
        if (input === source || input.value === zip) return;
        if (input === document.activeElement || input.dataset.qlsUserEditing === 'true') return;
        input.value = zip;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      syncing = false;
    }

    /* Do not commit while the customer is still typing. A five-digit ZIP is
       valid on its own, but it may also be the first half of ZIP+4. Sync only
       after one of the explicit check/submit actions broadcasts a result. */
    document.addEventListener('qls:delivery-zip-updated', function (event) {
      if (syncing) return;
      var zip = normalizeZip(event && event.detail && event.detail.zip || '');
      if (!isValidZip(zip)) return;
      writeStorage(ZIP_STORAGE_KEY, zip);
      window.dispatchEvent(new CustomEvent('qls:delivery-check-updated', {
        detail: { source: 'qls-product-delivery-submit', zip: zip }
      }));
      syncInputs(zip, null);
    });

    window.addEventListener('qls:delivery-check-updated', function (event) {
      var detail = event.detail || {};
      var zip = detail.result && detail.result.zip ? detail.result.zip : detail.zip;
      if (zip) syncInputs(zip, null);
    });

    window.addEventListener('qls:delivery-check-cleared', function () {
      syncing = true;
      document.querySelectorAll(selector).forEach(function (input) {
        if (!input.value) return;
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      syncing = false;
    });

    function hydrate() {
      var zip = normalizeZip(readStorage(ZIP_STORAGE_KEY));
      if (isValidZip(zip)) syncInputs(zip, null);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
    else hydrate();

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) hydrate();
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

})();
